/** 案件で求めるサブ条件：種別 提案書 */
export const RFP_REQUIRED_SUB_CONDITION_TYPE_PROPOSAL = {
    label: '提案書',
    value: 1,
};
/** 案件で求めるサブ条件：種別 成果物 */
export const RFP_REQUIRED_SUB_CONDITION_TYPE_DELIVERABLES = {
    label: '成果物',
    value: 2,
};
/** 案件で求めるサブ条件：種別 コミュニケーション */
export const RFP_REQUIRED_SUB_CONDITION_TYPE_COMMUNICATION = {
    label: 'コミュニケーション',
    value: 3,
};
/** 案件で求めるサブ条件：種別の一覧 */
export const RFP_REQUIRED_SUB_CONDITION_TYPES = [
    RFP_REQUIRED_SUB_CONDITION_TYPE_PROPOSAL,
    RFP_REQUIRED_SUB_CONDITION_TYPE_DELIVERABLES,
    RFP_REQUIRED_SUB_CONDITION_TYPE_COMMUNICATION,
];
